@if (dataArray.length>0) {
<div class="hw-grid" ngClass="{{config.tableClass || ''}}" role="grid">
    <div class="hw-grid-wrapper">
        <div class="export-data">
            @if (config.hideAction) {
            <div class="d-inline-block">
                @if (!showSearchBox) {
                <label class="label mr-5 mb-0 align-middle cursor-pointer" (click)="toggleSearch()">
                    <i class="fn-global-search pull-right blue "></i>
                </label>
                }
                @if (showSearchBox) {
                <fn-grid-search (search)="searchOnRows($event)" [config]="tblSearchConfig" (closeSearch)="closeSearch($event)">
                </fn-grid-search>
                }
            </div>
            }
            @if (!config.hideRptDownload) {
            <fn-grid-export [dataArray]="dataArray" [columArray]="columArray" [reportName]="config.reportName"></fn-grid-export>
            }
        </div>
        <fn-scrollbar [options]="{  autoHide: false }" [position]="'right'" class="fn-grid-scroll" [style.maxHeight.px]="scrHeight">
            <div class="hw-grid-main " id="simple-bar-body">
                @if (leftMetaArray.length>0) {
                <div class="sticky-left-panel" [ngClass]="{'grouping-row':config.isRowGrouping}">
                    <div class="hw-grid-header hw-grid-header-sticky">
                        <div class="hw-grid-header-row">
                            <ng-container *ngTemplateOutlet="colHeader;context:{colHeaderArray:leftMetaArray,isPinTo:true}"></ng-container>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="gridRowData;context:{colMetaArray:leftMetaArray,showAction:false,isPinTo:true}"></ng-container>
                </div>
                }
                <div class="hw-grid-body" [ngClass]="{'grouping-row':config.isRowGrouping}">
                    <div class="hw-grid-header hw-grid-header-sticky">
                        <div class="hw-grid-header-row">
                            @if (config.enableMultiSelect) {
                            <div class="hw-grid-header-cell hw-grid-header-cell-sticky">
                                <div class="hw-grid-header-cell-value">
                                    <span>&nbsp;</span>
                                </div>
                            </div>
                            }
                            <ng-container *ngTemplateOutlet="colHeader;context:{colHeaderArray:_cellMetaArray,isPinTo:false}"></ng-container>
                            @if (!config.hideAction) {
                            <div class="hw-grid-header-cell">
                                <div class="hw-grid-header-cell-value">
                                    <span innerHTML="{{ 'Action(s)' | fnTranslate }}">
                                    </span>
                                </div>
                                <div class="hw-grid-header-cell-value">
                                    <label class="lable" (click)="toggleSearch()" style="cursor: pointer;margin-bottom:-1px;margin-left: 10px;">
                                        <i class="fn-global-search pull-right blue "></i>
                                    </label>
                                    @if (showSearchBox) {
                                    <fn-grid-search (search)="searchOnRows($event)" [config]="tblSearchConfig" (closeSearch)="closeSearch($event)">
                                    </fn-grid-search>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="gridRowData;context:{colMetaArray:_cellMetaArray,showAction:!config.hideAction}"></ng-container>
                </div>
                @if (rightMetaArray.length>0) {
                <div class="sticky-right-panel" [ngClass]="{'grouping-row':config.isRowGrouping}">
                    <div class="hw-grid-header hw-grid-header-sticky">
                        <div class="hw-grid-header-row">
                            <ng-container *ngTemplateOutlet="colHeader;context:{colHeaderArray:rightMetaArray,isPinTo:true}"></ng-container>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="gridRowData;context:{colMetaArray:rightMetaArray,showAction:false,isPinTo:true}"></ng-container>
                </div>
                }
            </div>
        </fn-scrollbar>
        @if (uiDataArray.length<1) {
            <div class="col-12 mt-5 mb-5">
            <div class="row">
                <fn-no-data-box [showImg]="true" [isVerticalImg]="false" [headerTitle]=" 'No_Data_to_display' | fnTranslate "></fn-no-data-box>
            </div>
    </div>
    }
    @if (!config.isRowGrouping && dataArray.length>pageSize ) {
    <div class="hw-grid-status-bar">
        <div class="hw-grid-status-bar-left">
            {{config.footerLeftText}}
        </div>
        <div class="hw-grid-status-bar-center">
            {{config.footerCenterText}}
        </div>
        <div class="hw-grid-status-bar-right">
            <fn-pagination [currentPage]="currentPage" [totalPage]="totalPage" (changePage)="paginzationEvent($event)">
            </fn-pagination>
        </div>
    </div>
    }
</div>
</div>
}
@if (dataArray.length<1) {
    <div class="col-12 mt-5 mb-5">
    <div class="row">
        <!-- <span innerHTML="{{ 'No_Data_to_display' | fnTranslate }}"></span> -->
        <fn-no-data-box [showImg]="true" [isVerticalImg]="true" [showDesc]="true" [imgContainerheight]="600" [headerTitle]=" 'No_Data_to_display' | fnTranslate "></fn-no-data-box>
    </div>
    </div>
    }

    <!-- header row  -->
    <ng-template #colHeader let-colHeaderArray="colHeaderArray" let-isPinTo='isPinTo'>
        @for (column of colHeaderArray; track column) {
        @if (!column.isPinTo || isPinTo) {
        <div class="hw-grid-header-cell" [class.hidden]="column.isHidden" ngClass="{{column.styleClass || ''}}" [style.width]="column.autoWidth?'auto':column.width">
            <div class="hw-grid-header-cell-value" (click)="changeSort(column)">
                <span>{{column.headerName}}</span>
                @if (column.isSortable) {
                <i class="ml-5 mt-4 fa" [ngClass]="column.sortCls"></i>
                }
            </div>
            <div class="hw-grid-header-cell-filter">
                @if (column.isFilterEnable) {
                <fn-grid-header-filter [column]="column" (callback)="actionOnHeader($event,column)"></fn-grid-header-filter>
                }
            </div>
        </div>
        }
        }
    </ng-template>
    <!-- gird row  -->
    <ng-template #gridRowData let-colMetaArray="colMetaArray" let-showAction='showAction' let-isPinTo="isPinTo">
        @if (config.isRowGrouping) {
        <fn-grid-cell-group [templateRef]="gridGroupComp" [columnArray]="colMetaArray" [isPinTo]='isPinTo' [groupRowHash]="groupRowHash" [groupRowArray]="groupRowArray" [showAction]='showAction'>
        </fn-grid-cell-group>
        } @else {
        @for (row of uiDataArray; track row) {
        <div class="hw-grid-body-row">
            <ng-container *ngTemplateOutlet="gridGroupComp;context:{row:row,colHeaderArray:colMetaArray,showAction:showAction,isPinTo:isPinTo}"></ng-container>
        </div>
        }
        }
    </ng-template>

    <!-- gird row grouping or simple  -->
    <ng-template #gridGroupComp let-row="row" let-colHeaderArray='colHeaderArray' let-showAction='showAction' let-isPinTo='isPinTo'>
        @if (config.enableMultiSelect) {
        <div class="hw-grid-body-cell hw-grid-body-cell-sticky">
            <div class="hw-grid-body-cell-value">
                <span><img src="https://agcdn.altametrics.com/hw-img/DEV/other/drag.svg" /></span>
            </div>
        </div>
        }
        @for (column of colHeaderArray; track column) {
        @if (!column.isPinTo || isPinTo) {
        <div class="hw-grid-body-cell" [class.hidden]="column.isHidden" class="{{ cellStyleFormatting(row.data[column.field], column) }}">
            <div class="hw-grid-body-cell-value" ngClass="{{ column.cellClass || '' }}">
                <span>
                    <fn-grid-cell class="fn-grid-cell" [cellValue]="valueFormatter(row, column)" [column]="column" (updateAction)="updateCellAction($event, row, column)" [row]="row"
                                  (cellValueChange)="changCellAction($event, row, column)" (cellClick)="cellClickAction($event, row, column)" (cellFocus)="cellFocusAction($event, row, column)"
                                  (cellBlur)="cellBlurAction($event, row, column)" (selectionChange)="selectionChange($event,row, column)">
                    </fn-grid-cell>
                </span>
            </div>
        </div>
        }
        }
        @if (showAction) {
        <div class="hw-grid-body-cell">
            <div class="hw-grid-body-cell-value">
                @for (rowAction of config.rowActionArray; track rowAction) {
                <button (click)="onRowAction(rowAction)" class="btn btn-link btn-action {{rowAction.styleClass}}">
                    <i class="{{ rowAction.icon }} fa-lg font-16" title="Edit"></i>
                </button>
                }
            </div>
        </div>
        }
    </ng-template>
